import styled from "styled-components";

export const Description = styled.h1`
  font-weight: bold;
  line-height: 22px;
  color: #666666;
  padding: 5rem;
  text-align: center;
`;
